/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetRegisteredUsersReportOptions, GetRegisteredUsersReportStatus200, GetRegisteredUsersReportStatus422 } from '../models/GetRegisteredUsersReport'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getRegisteredUsersReport } from '../clients/axios/getRegisteredUsersReport'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getRegisteredUsersReportQueryKey = ({ query }: Omit<GetRegisteredUsersReportOptions, 'headers'>) => [{ url: '/reports/registered_users' }, ...(query ? [query] : [])] as const

type GetRegisteredUsersReportQueryKey = ReturnType<typeof getRegisteredUsersReportQueryKey>

export function getRegisteredUsersReportQueryOptions({ query }: GetRegisteredUsersReportOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getRegisteredUsersReportQueryKey({ query })
  return queryOptions<GetRegisteredUsersReportStatus200, ResponseErrorConfig<GetRegisteredUsersReportStatus422>, GetRegisteredUsersReportStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getRegisteredUsersReport({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Registered Users
 * {@link /reports/registered_users}
 */
export function useGetRegisteredUsersReport<TData = GetRegisteredUsersReportStatus200, TQueryData = GetRegisteredUsersReportStatus200, TQueryKey extends QueryKey = GetRegisteredUsersReportQueryKey>({ query }: { query: GetRegisteredUsersReportOptions['query'] | (() => GetRegisteredUsersReportOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<GetRegisteredUsersReportStatus200, ResponseErrorConfig<GetRegisteredUsersReportStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getRegisteredUsersReportQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getRegisteredUsersReportQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetRegisteredUsersReportStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
